import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../contexts/ModalContext';

const BASE = 'SHARED_COMPONENTS.CONFIRMATION_MODAL';

type Props = {
  id: string;
  headerTitle: string;
  title: string;
  message: string;
  confirmationText: string;
  onConfirm: () => Promise<void>;
};

function ConfirmationModal({ id, headerTitle, title, message, confirmationText, onConfirm }: Props) {
  const { t } = useTranslation();

  const { closeModal } = useContext(ModalContext);

  const handleClose = () => {
    closeModal(id);
  };

  const handleConfirmation = async () => {
    await onConfirm();
    handleClose();
  };

  return (
    <Dialog id={id} modal size="sm" onClose={handleClose} aria-label={t(`${BASE}.A11Y_LABEL`)}>
      <Dialog.Header
        title={headerTitle}
        onClose={handleClose}
        aria-label={t(`${BASE}.HEADER.ACTIONS.A11Y_LABEL`)}
        danger
      />
      <Dialog.Body>
        {title && <Dialog.BodyTitle>{title}</Dialog.BodyTitle>}
        {message}
      </Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsRight={{
          'aria-label': undefined,
          role: undefined,
          children: (
            <>
              <Button prominence="neutral" onClick={handleClose} key="cancel">
                {t(`${BASE}.ACTIONS.DISCARD`)}
              </Button>
              <Button prominence="danger" onClick={handleConfirmation} key="confirm">
                {confirmationText}
              </Button>
            </>
          ),
        }}
      />
    </Dialog>
  );
}

export default ConfirmationModal;
